<template>
    <div class="photo-album">
        <div class="no-imgList" v-if="imgList.length==0">暂时相册为空</div>
        <swipe  class="my-swipe" v-else   :speed="setting.autoplaySpeed">
            <swipe-item :key="index" v-for="(imgItem,index) in imgList">
                <img class="img" :src="imgItem.picUrl" alt="">
            </swipe-item>
        </swipe>

    </div>
</template>

<script>
    import api from '../../../api/api'
    import 'vue-swipe/dist/vue-swipe.css' ;
    import photoAlbumItem from './photoAlbumItem'
    import {mapState} from 'vuex'
    var self
    export default {
        components: {
            photoAlbumItem
        },
        props:['memorialId'],
        data(){
            return{
                setting: {
                    autoplay: false,
                    autoplaySpeed: 3000,
                },
                imgList:[]
            }
        },
        watch:{
            memorialId: {
                immediate:true,
                handler(val) {
                    this.imgList = [];
                    this.memorialId = val;
                    this.getImgList()
                }
            }
        },
        created(){
            self = this;
        },
        activated(){
            this.getImgList()
        },
        methods:{
            getImgList() {
                // console.log('currentMemorialId--->>',this.memorialId)
                if(!this.memorialId)return
                api.getAlbumList({memorialId:this.memorialId}).then(res =>{
                    // console.log('相册：',res.rows)
                    self.imgList = res.rows
                }).catch(error =>{
                    self.$Message.error(error.info)
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .photo-album{
        /*overflow: hidden;*/
        min-height: 500px;
        padding: 60px 50px;
        .no-imgList{
            text-align: center;
            font-size: 20px;
        }
    }
    .my-swipe {
        height: 600px;
        color: #fff;
        font-size: 30px;
        text-align: center;
        .img{
            height: 100%;
        }
    }
</style>
